<template>
    <Wrapper>
        <div class="flex-fill">
            <section class="row mt-1">
                <div class="col-lg-6 pb-3 wow fadeInUp">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Page Views</h4>
                            <div class="my-xl-auto py-2">
                                <LineChart height="320" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 pb-3 wow fadeInUp" data-wow-delay=".5s">
                    <CardDevices />
                </div>
                <div class="col-xl-3 col-lg-12 pb-3 wow fadeInUp" data-wow-delay="1s">
                    <CardActivity />
                </div>
            </section>
            <section class="row">
                <div class="col-xl-9 col-md-8 py-3">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item"><a href="#tab1" class="nav-link text-uppercase active" data-toggle="tab" data-target="#tab1" role="tab">Log</a></li>
                                <li class="nav-item"><a href="#tab2" class="nav-link text-uppercase" data-toggle="tab" data-target="#tab2" role="tab">Users</a></li>
                            </ul>
                            <div class="tab-content py-4">
                                <div class="tab-pane active" id="tab1" role="tabpanel">
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <span class="float-right text-muted small">11.12.2019T8:02:10.35Z</span>
                                            <h5 class="card-title"><span class="badge badge-pill bg-warning">&nbsp;</span> Vuedoo</h5>
                                            <p class="card-text">The process completed, but the write disk is at 10% remaining. 
                                            <button class="btn btn-sm btn-outline-warning align-bottom ml-3">Details</button>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <span class="float-right text-muted small">11.12.2019T8:00:20.10Z</span>
                                            <h5 class="card-title"><span class="badge badge-pill bg-success">&nbsp;</span> Esque</h5>
                                            <p class="card-text">The process completed successfully.</p>
                                        </div>
                                    </div>
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <span class="float-right text-muted small">11.12.2019T7:59:33.12Z</span>
                                            <h5 class="card-title"><span class="badge badge-pill bg-success">&nbsp;</span> Nachure</h5>
                                            <p class="card-text">The process completed successfully.</p>
                                        </div>
                                    </div>
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <span class="float-right text-muted small">11.12.2019T7:57:04.13Z</span>
                                            <h5 class="card-title"><span class="badge badge-pill bg-danger">&nbsp;</span> Admine</h5>
                                            <p class="card-text">The process completed, but an error occured. 
                                            <button class="btn btn-sm btn-outline-danger align-bottom ml-3">Details</button></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="tab2" role="tabpanel">
                                    <div class="row">
                                        <div class="col-xl-4 pb-3">
                                            <div class="card text-white bg-primary d-none d-xl-block">
                                                <div class="card-body">
                                                    <h3 class="card-title">Bots</h3>
                                                    <p class="card-text">Click on a robot friend to learn more about them.</p>
                                                    <button class="btn btn-outline-light">Button</button>
                                                </div>
                                            </div>
                                            <hr class="d-none d-xl-block" />
                                            <div class="card float-left w-100 text-white bg-dark mb-2">
                                                <div class="card-body">
                                                    <div class="float-right dropdown show"><button data-toggle="dropdown" class="btn btn-link dropdown-toggle p-0 text-white"><i class="align-middle lnr lnr-cog"></i></button>
                                                        <div class="dropdown-menu dropdown-menu-right">
                                                            <button class="dropdown-item">Action</button>
                                                            <button class="dropdown-item">More</button>
                                                        </div>
                                                    </div>
                                                    <h4 class="card-title">Working</h4>
                                                    <p class="card-text">
                                                        This template features <em>working</em> components to demonstrate realistic use and implementation.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div id="accordion" class="border rounded" role="tablist" aria-multiselectable="true">
                                                <a role="tab" id="headingOne" data-toggle="collapse" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne" class="card-header d-block collapsed">
                                                    Amy Shurot
                                                </a>
                                                <div id="collapseOne" role="tabpanel" class="collapse" data-parent="#accordion">
                                                    <div class="card border-0">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-lg-9 col-md-7">
                                                                    <h5>Web / UI Developer</h5>
                                                                    <p>
                                                                        I love to read, hang out with friends, listen to music, and learn new things. I've been with ACME since the dotcom boom in 1999.
                                                                    </p>
                                                                    <p><span class="badge badge-info tags">html5</span> <span class="badge badge-info tags">css3</span> <span class="badge badge-info tags">nodejs</span></p>
                                                                </div>
                                                                <div class="col-lg-3 col-md-5 col-10 mx-auto text-center">
                                                                    <img src="assets/w33.jpg" alt="" class="mx-auto rounded-circle img-fluid bg-dark" />
                                                                    <ul title="Ratings" class="list-inline ratings text-center">
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star-half text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href=".">.<span class="lnr lnr-star-empty text-success"></span></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">20.7K</h3> <small>Followers</small>
                                                                    <button class="btn btn-block btn-outline-secondary text-truncate">Follow</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">245</h3> <small>Following</small>
                                                                    <button class="btn btn-outline-secondary btn-block text-truncate">View Profile</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">43</h3> <small>Snippets</small>
                                                                    <button type="button" class="btn btn-outline-secondary btn-block text-truncate">Show</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a role="tab" id="headingTwo" data-toggle="collapse" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" class="card-header d-block collapsed">
                                                    Devin Wozniak
                                                </a>
                                                <div id="collapseTwo" role="tabpanel" aria-labelledby="headingTwo" class="collapse show" data-parent="#accordion">
                                                    <div class="card border-0">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-lg-9 col-md-7">
                                                                    <h5>Network Admininstrator</h5>
                                                                    <p>
                                                                        I love to read, hang out with friends, listen to music, and learn new things. I got a BS in CS from Bot University.
                                                                    </p>
                                                                    <p><span class="badge badge-info tags">html5</span> <span class="badge badge-info tags">css3</span> <span class="badge badge-info tags">nodejs</span></p>
                                                                </div>
                                                                <div class="col-lg-3 col-md-5 col-10 text-center mx-auto">
                                                                    <img src="assets/m83.jpg" alt="bot" class="mx-auto rounded-circle img-fluid bg-dark" />
                                                                    <ul title="Ratings" class="list-inline ratings text-center">
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star-half"></span></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">289</h3> <small>Followers</small>
                                                                    <button class="btn btn-block btn-outline-secondary"><span class="fa fa-plus-circle"></span> Follow</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">89</h3> <small>Following</small>
                                                                    <button class="btn btn-outline-secondary btn-block"><span class="fa fa-user"></span> View Profile</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">64</h3> <small>Snippets</small>
                                                                    <button type="button" class="btn btn-outline-secondary btn-block"><span class="fa fa-gear"></span> Options</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a role="tab" id="headingThree" data-toggle="collapse" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree" class="card-header d-block collapsed">
                                                    Thomas Rank
                                                </a>
                                                <div id="collapseThree" role="tabpanel" aria-labelledby="headingThree" class="collapse" data-parent="#accordion">
                                                    <div class="card border-0">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-lg-9 col-md-7">
                                                                    <h5>Quarterback</h5>
                                                                    <p>
                                                                        I love to play football and spend time with my beautiful supermodel wife, Gizel.
                                                                    </p>
                                                                    <p><span class="badge badge-info tags">passing</span> <span class="badge badge-info tags">receptions</span> <span class="badge badge-info tags">yards</span></p>
                                                                </div>
                                                                <div class="col-lg-3 col-md-5 col-10 mx-auto text-center">
                                                                    <img src="assets/m20.jpg" alt="bot" class="mx-auto rounded-circle img-fluid bg-dark" />
                                                                    <ul title="Ratings" class="list-inline ratings text-center">
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star text-success"></span></a></li>
                                                                        <li class="list-inline-item"><a href="."><span class="lnr lnr-star-empty text-success"></span></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">17.6K</h3> <small>Followers</small>
                                                                    <button class="btn btn-block btn-outline-secondary">Follow</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">120</h3> <small>Following</small>
                                                                    <button class="btn btn-outline-secondary btn-block">View Profile</button>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <h3 class="mb-0">2</h3> <small>Snippets</small>
                                                                    <button type="button" class="btn btn-outline-secondary btn-block">Options</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4 py-3 d-sm-block d-none">
                    <div class="card bg-primary border-0 h-100 shadow-sm">
                        <div class="card-body d-flex flex-column justify-content-between">
                            <h4 class="font-weight-light">
                                <div class="float-right dropdown show"><button data-toggle="dropdown" class="btn btn-link p-0 dropdown-toggle"><i class="lnr lnr-cog"></i></button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <button class="dropdown-item">Action</button>
                                        <button class="dropdown-item">Another action</button>
                                    </div>
                                </div>
                                Leads
                            </h4>
                            <div class="text-center py-2">
                                <MiniLineChart ref="miniLineChart1" :data="dataLine1" class="mb-2 p-1 mx-auto" height="130" />
                                May 2018
                            </div>
                            <div class="text-center py-2">
                                <MiniLineChart ref="miniLineChart2" :data="dataLine2" class="mb-2 p-1 mx-auto" height="130" />
                                Jun 2018
                            </div>
                            <div class="text-center py-2">
                                <MiniLineChart ref="miniLineChart3" :data="dataLine3" class="mb-2 p-1 mx-auto" height="130" />
                                July 2018
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="row">
                <div class="col py-3">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <DataTable /> 
                        </div>
                    </div>
                </div>
            </section>
            <div class="row mt-1 wow fadeInUp" data-wow-delay=".3s">
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Health</h5>
                                <h3 class="text-nowrap">99.3%</h3>
                            </div>
                            <div class="col bg-light text-success d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="." lass="nav-link pb-0" title="View details"><span class="d-inline-block lnr lnr-heart"></span></a></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Cycles</h5>
                                <h3>53</h3></div>
                            <div class="col bg-light text-success d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="." class="nav-link pb-0" title="View details"><span class="d-inline-block lnr lnr-history"></span></a></h1></div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Storage</h5>
                                <h3 class="text-nowrap">69%</h3>
                            </div>
                            <div class="col bg-light text-success d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="." class="nav-link pb-0" title="View details"><span class="d-inline-block lnr lnr-database"></span></a></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Signal</h5>
                                <h3>4.1</h3></div>
                            <div class="col bg-light text-success d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="." class="nav-link pb-0" title="View details"><i class="lnr lnr-heart-pulse"></i></a></h1></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, LineChart, DonutChart, MiniLineChart, CardDevices, CardActivity, DataTable } from '../../components';

export default {
    components: {
        Wrapper,
        LineChart,
        DonutChart,
        MiniLineChart,
        CardDevices,
        CardActivity,
        DataTable
    },
    data() {
        return {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [{
                    "borderWidth": 0,
                    "data": [10, 20, 60]
                }]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [{
                    "backgroundColor": ["red","pink","lime"],
                    "borderWidth": 0,
                    "data": [10, 70, 5]
                }]
            },
            dataLine1: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [10, 11, 8, 9, 10],
                    fill: false
                  }
                ]
            },
            dataLine2: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [5, 7, 8, 9, 6],
                    fill: false
                  }
                ]
            },
            dataLine3: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [11, 9, 8, 10, 7],
                    fill: false
                  }
                ]
            }
        }
    }
};
</script>
